React = require 'react'
$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
l = require 'app/scripts/lib/localize'
log = require 'app/scripts/debug/log'
_ = require 'underscore'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
{ usesEnglish } = require '@trello/locale'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ renderTopLevelComponent } = require 'app/scripts/controller/renderTopLevelComponent'
{ LazyTemplatesContainer } = require 'app/src/components/Templates'
{ ShortcutsOverlay } = require 'app/src/components/ShortcutsOverlay'
{ ShortcutsPage } = require 'app/src/components/ShortcutsPage'
{ Campaigns, MoonshotSteps } = require 'app/common/data/campaigns'
{ isDesktop } = require '@trello/browser'
{ trackGTMEvent } = require '@trello/analytics'

module.exports =
  routes: [
    ['create-first-team', 'createFirstTeamView']
    ['shortcuts', 'shortcutsView']
    ['shortcuts/overlay', 'shortcutsViewOverlay']
    ['blank', 'blankView']
    ['select-org-to-upgrade', 'businessClassSelectOrgView']
    ['select-team-to-upgrade', 'businessClassSelectTeamView']
    ['search(?*query)', 'searchView']
    ['templates(/:category)(/:templateSlug)(/)', 'templatesGalleryPublic']
    ['templates(/:category)(/:templateSlug)(/:referrerUsername)/recommend(/)', 'templatesGalleryPublic']
  ]

  createFirstTeamView: ->
    featureFlagClient.client.waitUntilReady().then(=>
      if !featureFlagClient.get('btg.moonshot', false)
        return @navigate '/', replace: true, trigger: true

      if isDesktop()
        return Auth.me().dismissCampaign Campaigns.MOONSHOT, =>
          @navigate '/', replace: true, trigger: true

      if ($.cookie('simulateNewUser') || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
        trackGTMEvent({
          event: 'trello.possibleNewSignup'
        })

      Promise.using @getSpinner(), =>
        # Dependency required at call site to avoid import cycles, do not lift to top of module
        ModelLoader = require 'app/scripts/db/model-loader'
        ModelLoader.await('headerData').then =>
          me = Auth.me()

          if !me.isLoggedIn()
            return window.location = '/login'
          else if me.get('enterprises').length > 0
            return Auth.me().dismissCampaign Campaigns.MOONSHOT, =>
             @navigate '/', replace: true, trigger: true

          if me.campaignIsActive(Campaigns.MOONSHOT)
            @renderCreateFirstTeam()
          else if me.get('idOrganizations').length > 0 ||
           !usesEnglish() ||
           me.campaignIsDismissed(Campaigns.MOONSHOT)
            @navigate '/', replace: true, trigger: true
          else
            return me.addCampaign(
              { name: Campaigns.MOONSHOT, currentStep: MoonshotSteps.CREATE_TEAM },
              @renderCreateFirstTeam.bind(this)
            )
      .done()
    )

  renderCreateFirstTeam: ->
    me = Auth.me()
    campaign = me.getCampaign(Campaigns.MOONSHOT)
    if MoonshotSteps.WELCOME == campaign.currentStep
      if me.get('idOrganizations').length > 0
        return @navigate "org/#{me.get('idOrganizations')[0]}", {
          trigger: true,
          replace: true
        }
      else
        # This shouldn't happen... but to be safe...
        me.dismissCampaign(Campaigns.MOONSHOT)
        return @navigate '', { trigger: true, replace: true }

    @clearPreviousView()
    @setViewType('onboarding-create-first-team')
    @title('Welcome To Trello')
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    CreateFirstTeamView = require 'app/scripts/views/create-first-team/create-first-team'
    view = @topLevelView(CreateFirstTeamView, me)
    $('#trello-root').addClass('body-hide-header')
    $('#content').html(view.render().el)

  businessClassSelectOrgView: ->
    @navigate '/select-team-to-upgrade', replace: true, trigger: true
    return

  businessClassSelectTeamView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BusinessClassSelectOrgView = require 'app/scripts/views/organization/business-class-select-org-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    pathname = '/select-team-to-upgrade'

    if !Auth.isLoggedIn()
      window.location = "/login?returnUrl=#{ pathname }"
      return

    Promise.using @getSpinner(), =>
      ModelLoader.for('top-level', 'loadMyOrganizationsWithoutBoards').then (member) =>
        @setViewType('select-org')

        notPremiumOrgs = _.filter(member.organizationList.models, (org) -> !org.isPremium())
        if notPremiumOrgs.length == 1
          @navigate "/#{ notPremiumOrgs[0].get('name') }/billing", { trigger: true }
          return

        @setLocation
          title: l('select organization to upgrade to business class')
          location: pathname

        @clearPreviousView()
        view = @topLevelView(BusinessClassSelectOrgView, member)

        @showHeader()
        $('#content').html view.render().el
    .done()

  searchView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SearchInputView = require 'app/scripts/views/search/search-input-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SearchState = require 'app/scripts/view-models/search-state'

    log('controller', ['searchView'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        if !Auth.isLoggedIn()
          @displayErrorPage()
          return

        @setViewType('search')
        @clearPreviousView()
        me = Auth.me()
        headerCache = ModelCache

        query = Util.getQueryParameter('q', "")
        inputView = @topLevelView(SearchInputView, me, modelCache: headerCache)
        resultsView = inputView.getResultsView()

        SearchState.setQuery(query)
        resultsView.update()
        @showHeader({ noSearch: true })

        $('#trello-root').addClass('body-search-page')

        $('#content')
        .append(inputView.render().el)
        .append(resultsView.render().el)

        _.defer -> inputView.focusInput()
        return
    .done()

  blankView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('blank')
        @clearPreviousView()
        @showHeader()
        return
    .done()

  shortcutsViewOverlay: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Dialog = require 'app/scripts/views/lib/dialog'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    ModelLoader.await 'headerData'
    .then =>
      title = l('keyboard shortcuts')
      location = 'shortcuts/overlay'

      if @onAnyBoardView()
        @saveBoardsView()
        Dialog.show
          reactElement: React.createElement ShortcutsOverlay,
            onClose: ->
              Dialog.hide()
          maxWidth: 550
          hide: (isNavigating) =>
            if !isNavigating
              @loadBoardsView()
        @setLocation(title, location)
      else
        @navigate '/shortcuts', replace: true, trigger: true

    return

  shortcutsView: ->
    title = l('keyboard shortcuts')
    location = 'shortcuts'

    if @onAnyBoardView()
      @navigate '/shortcuts/overlay', replace: true, trigger: true
    else
      log('controller', [location + 'View'])
      renderTopLevelComponent(React.createElement(ShortcutsPage))
      .then =>
        $('#trello-root').addClass('body-single-column')
        @focusContent()
        @setLocation({ title, location })

  templatesGalleryPublic: (category, templateSlug, referrerUsername) ->
    featureFlagClient.client.waitUntilReady().then(=>
      if featureFlagClient.get('templates.public-gallery', false) && featureFlagClient.get('templates.logged-in-gallery', false) && Auth.isLoggedIn()
        @templatesGalleryLoggedIn(category, templateSlug, referrerUsername)
        return
      if featureFlagClient.get('templates.public-gallery', false)
        if referrerUsername
          $.cookie('referrer', referrerUsername, { path: '/', expires: 14 })
        shortLink = _.last(if templateSlug? then templateSlug.split('-') else [])
        # setViewType sets @currentModel to null. This is so that when we navigate
        # to templates from a board things like board headers don't hang around
        @setViewType('blank')

        if templateSlug && (!shortLink? || !Util.isShortLink(shortLink))
          @navigate '/templates', replace: true, trigger: true
          return

        renderTopLevelComponent(React.createElement(LazyTemplatesContainer, {
          category,
          shortLink
        }))
      else
        @navigate '/', replace: true, trigger: true
    )

  errorView: ({ title, location, data }) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ErrorView = require 'app/scripts/views/error/error-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('error')
        @clearPreviousView()
        @showHeader()

        fullName = Auth.me()?.get('fullName') ? ''

        _.extend data, { fullName: fullName }

        errorView = @topLevelView(ErrorView, data)
        $('#content').append(errorView.render().el)
        @focusContent()

        @setLocation({ title, location })
    .done()
